<template>
  <div>
    <div class="tab-container">
      <div class="tab-header">
        <div class="wd-45 tab-header-left"><h1 role="heading" aria-level="1" tabindex="-1">{{ tabName }}</h1></div>
        <div class="wd-45"></div>
      </div>
      <div class="tab-form">
        <div>
          <base-user-data-form
            @userDataChanged="setUserData($event)"
          >
          </base-user-data-form>
        </div>
        <div>
          <usb-data-form
            :usbProducts="USBProducts"
            @usbDataChanged="setUSBData($event)"
          ></usb-data-form>
        </div>
        <div v-if="showLicenseAgreement() && usbProduct && (USBIFCert === 'no' || (USBIFCert === 'yes' && vid !== null))">
          <base-license-agreement
            :checkbox-name="'usbIAgree'"
            :linkName="'End User License Agreement'"
            :linkModalID="'#usb-license-agreement'"
            :linkID="'usb-la-link'"
            :checkboxValue="isUSBLicenseAccepted"
            @licenseAgreementClicked="setLicenseText()"
          ></base-license-agreement>
          <p class="error-msg" v-if="!isUSBLicenseAccepted && laModalOpened" role="alert">Licensing reuse requires you accept the terms and conditions before we can process your request.</p>
          <base-modal
            :modalID="'usb-license-agreement'"
            :modalSize="'xl'"
            :modalTitle="(USBIFCert === 'no' && !isMicrochipProduct(usbProduct)) ? 'Message': ''"
            :showCloseButton="(USBIFCert === 'no' && !isMicrochipProduct(usbProduct)) ? false : true"
            :showCloseHyperlink="(USBIFCert === 'no' && !isMicrochipProduct(usbProduct)) ? true : false"
            :closeURL="'https://www.microchip.com/en-us/products/interface-and-connectivity/usb'"
            :showSecondaryButton="!(USBIFCert === 'no' && !isMicrochipProduct(usbProduct))"
            :showPrimaryButton="true"
            :secondaryButtonName="'I Decline'"
            :primaryButtonName="(USBIFCert === 'no' && !isMicrochipProduct(usbProduct)) ? 'OK' : 'I Accept'"
            :buttonSize="'medium'"
            :modalFooterText="(USBIFCert === 'no' && !isMicrochipProduct(usbProduct)) ? '' : 'By clicking the I Accept button, you agree that you have read, understand, and accept the terms above, and grant Microchip permission to contact you regarding any aspect of this application'"
            @primaryButtonClicked="setUSBLA(true, $event)"
            @secondaryButtonClicked="setUSBLA(false)"
          >
            <div id="usb-license-agreement-text"></div>
          </base-modal>
        </div>
        <div class="buttons-container margin-top-45 margin-bottom-20">
          <button class="button medium" @click="resetForm()">Cancel</button>
          <button
            class="button medium margin-left-10"
            :disabled="
              userDataFormInvalid || usbDataFormInvalid || (!isUSBLicenseAccepted && showLicenseAgreement()) || isLoading
            "
            @click="sendUSBDataToDB()"
          >
            <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
            Submit
          </button>
        </div>
        <p v-if="isUSBAPIResponseError" role="alert" class="error-msg">Something went wrong. Please try after sometime!</p>
      </div>
    </div>
  </div>
  <div>
    <Teleport to="html">
      <div
        class="modal"
        tabindex="0"
        id="usb-success-modal"
        data-bs-backdrop="static"
        aria-modal="true"
        role="alertdialog"
      >
        <div
          class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
        >
          <div class="modal-content">
            <div class="modal-header">
              <p>Message</p>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close button" @click="closeModal()"></button>
            </div>
            <div class="modal-body">
              <p id="alert-message"></p>
            </div>
            <div class="modal-footer">
              <div>
                <button
                  type="button"
                  class="button small"
                  id="usb-success-ok"
                  data-bs-dismiss="modal"
                  aria-label="OK button"
                  tabindex="0"
                  @click="redirectTo()"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>
<script>

import {BaseUserDataForm, BaseLicenseAgreement, BaseModal} from '@microchip/common-vue-components';
import UsbDataForm from "../components/UsbDataForm.vue";


export default {
  props: ["tabName"],
  components: {
    BaseUserDataForm,
    UsbDataForm,
    BaseLicenseAgreement,
    BaseModal,
},
  data() {
    return {
      laModalOpened: false,
      USBIFCert: null,
      firstName: "",
      lastName: "",
      email: "",
      name: "",
      company: "",
      phone: "",
      fax: "",
      address: "",
      city: "",
      postalCode: "",
      country: "",
      state: "",
      userDataFormInvalid: true,
      usbDataFormInvalid: true,
      usbProduct: null,
      productNumber: "",
      vid: null,
      pid: null,
      description: "",
      isUSBLicenseAccepted: false,
      changedRef: null,
      isLoading: false,
    };
  },
  methods: {
    closeModal() {
      this.isLoading = false;
      window.location.href = "https://www.microchip.com/en-us/products/interface-and-connectivity/usb"
    },
    resetForm() {
      window.location.reload(true);
    },
    setUSBLA(value, buttonName) {
      if(buttonName === 'OK'){
        window.location.href="http://www.microchip.com/USB";
      } else {
        this.laModalOpened = true;
        this.isUSBLicenseAccepted = value;
      }
    },
    setUserData(userData) {
      this.firstName = userData.firstName;
      this.lastName = userData.lastName;
      this.email = userData.email;
      this.name = userData.name;
      this.company = userData.company;
      this.phone = userData.phone;
      this.fax = userData.fax;
      this.address = userData.address;
      this.city = userData.city;
      this.postalCode = userData.postalCode;
      this.country = userData.country;
      this.state = userData.state;
      this.userDataFormInvalid = userData.isFormInvalid;
    },
    setUSBData(usbData) {
      this.usbProduct = usbData.usbProduct;
      this.USBIFCert = usbData.USBIFCert;
      this.productNumber = usbData.productNumber;
      this.vid = usbData.vid;
      this.pid = usbData.pid;
      this.description = usbData.description;
      this.usbDataFormInvalid = usbData.isFormInvalid;
      this.changedRef = usbData.ref;
      if(this.changedRef === 'usbProduct' || this.changedRef === 'usbIF') {
        this.isUSBLicenseAccepted = false;
      }
    },
    setLicenseText() {
      const isMCHP = this.isMicrochipProduct(this.usbProduct);
      if (this.USBIFCert === "no") {
        if (isMCHP) {
          document.getElementById("usb-license-agreement-text").innerHTML =
          this.$store.getters["usb/USBLicenseTexts"]?.[0]?.emilBodyHTML;
        }
        else {
          document.getElementById("usb-license-agreement-text").innerText = 'Microchip USB devices are preprogrammed from the factory with default values which enable them to operate without custom programming.  Custom programming or a sublicense of the Microchip VID/PID/DID is only necessary if USB Logo Certification is required for this product.';
        }
      } else if (isMCHP && this.USBIFCert === "yes" && this.vid === "no") {
        document.getElementById("usb-license-agreement-text").innerHTML =
        this.$store.getters["usb/USBLicenseTexts"]?.[0]?.emilBodyHTML;
      } else if (!isMCHP && this.USBIFCert === "yes" && this.vid === "no") {
        document.getElementById("usb-license-agreement-text").innerHTML =
        this.$store.getters["usb/USBLicenseTexts"]?.[1]?.emilBodyHTML;
      } else if (isMCHP && this.USBIFCert === "yes" && this.vid === "yes") {
        document.getElementById("usb-license-agreement-text").innerHTML = "";
      } else if (!isMCHP && this.USBIFCert === "yes" && this.vid === "yes") {
        document.getElementById("usb-license-agreement-text").innerHTML =
        this.$store.getters["usb/USBLicenseTexts"]?.[1]?.emilBodyHTML;
      }
       // eslint-disable-next-line no-undef
      $("#usb-license-agreement").modal('show');
    },
    isMicrochipProduct(product) {
      const mchpPattern = 'PIC,DSPIC,MCP,AT,SAM'.split(',');
      for (let i = 0; i < mchpPattern.length; i++) {
          if (product?.toUpperCase().match("^" + mchpPattern[i])) {
              return true;
          }
      }
      return false;
    },
    redirectTo() {
      this.isLoading = false;
      // eslint-disable-next-line no-undef
      const url = $('#usb-success-ok').attr('name');
      window.location.href = url;
    },
    sendUSBDataToDB() {
      this.isLoading = true;
      const payload = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        productDesc: this.productNumber,
        productUsed: this.usbProduct,
        companyName: this.company,
        address: this.address,
        phone: this.phone,
        createdOn: new Date(),
        licenseUsedFor: this.description,
        city: this.city,
        country: this.country,
        postalCode: this.postalCode,
        usbiFcert: this.USBIFCert === "yes" ? true : false,
        ownVID: this.vid === "yes" ? true : false,
        defaultPID: this.pid === "yes" ? true : false,
        alertMessage: "",
        redirectUrl: "",
      };
      this.$store.dispatch("usb/updateUSBFormData", payload);
    },
    showLicenseAgreement() {
      return !(this.isMicrochipProduct(this.usbProduct) && this.USBIFCert === "yes" && this.vid === "yes");
    }
  },
  computed: {
    USBProducts() {
      return this.$store.getters["usb/USBProducts"];
    },
    isUSBAPIResponseError() {
      const isUSBError = this.$store.getters["usb/USBAPIError"];
      return isUSBError;
    },
  },
  mounted() {
    this.$store.dispatch("usb/getUSBProducts");
    this.$store.dispatch("usb/getLicenseTexts");
  },
};
</script>
<style scoped>
  .fa {
    margin-right: 5px;
  }
</style>